import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M3 12h3v7h3v-7h3V9H3zm6-5h5v12h3V7h5V4H9z"
}), 'FormatSizeTwoTone');